import { isNil } from 'lodash-es';

/*
  @param value: primitive type
  @description: check value isNil or empty string. 대시보드에서 연계 시 빈문자열로 연계되는 경우가 있어 체크
*/
export const isNilOrEmpty = (value: any): value is null | undefined | '' =>
  isNil(value) || value === '';

export const checkRequiredFields = (
  items: { field: string; value: any }[],
): { isValid: boolean; emptyFields: string[]; message: string } => {
  const emptyFields = items.reduce<string[]>((acc, { field, value }) => {
    if (isNilOrEmpty(value)) {
      acc.push(field);
    }
    return acc;
  }, []);

  return {
    isValid: emptyFields.length === 0,
    emptyFields,
    message: emptyFields.length > 0 ? `Required fields: ${emptyFields.join(', ')}` : '',
  };
};
